module.exports = __webpack_public_path__ + "img/back-arrow.c3970159.svg";